import * as angular from 'angular';
import './queueItem.scss';
import { QueuesTracks } from '../QueueManagementConstants';
export class QueueItemController {
    static $inject = ['SegmentService', '$translate', 'ngToast', '$state', 'QueuesService'];
    constructor(SegmentService, $translate, ngToast, $state, QueuesService) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.$state = $state;
        this.QueuesService = QueuesService;
        this.elementId = 'queue';
        this.onToggle = async ({ detail }) => {
            this.data.isActive = detail.checked;
            this.trackPayload.enabled = detail.checked;
            this.SegmentService.createApplicationTrack({ trackEvent: QueuesTracks.QUEUE_ENABLED, application: this.application,
                payload: this.trackPayload });
            try {
                this.isLoading = true;
                await this.QueuesService.save(this.data);
            }
            catch (ex) {
                const errorMsg112 = await this.$translate('modules.application.detail.attendance.queue-management.warning');
                this.ngToast.danger(errorMsg112);
            }
            finally {
                this.isLoading = false;
            }
        };
    }
    async $onInit() {
        this.queue = angular.copy(this.data);
        this.trackPayload = { source: this.isManagerView ? QueuesTracks.SOURCE.PORTAL : QueuesTracks.SOURCE.BUILDER };
    }
    editModel() {
        this.queue = angular.copy(this.data);
        this.$state.go('auth.application.detail.attendance.queueManagement.queue', { id: this.queue.id });
    }
    $deleteModel() {
        if (!this.canEditQueue) {
            return;
        }
        this.onDelete({ $item: this.queue });
    }
    $cancelModel() {
        this.onCancel();
        this.data.opened = false;
        this.queue = angular.copy(this.data);
    }
    onCloseQueue() {
        this.queue.opened = false;
        this.data = this.queue;
    }
    onOpenQueueChild() {
        this.queue.opened = true;
        this.data = this.queue;
        this.onOpenQueue();
        this.queue = angular.copy(this.data);
    }
    async updateQueue() {
        this.queue.opened = this.isManagerView ? false : this.queue.opened;
        try {
            if (this.onSave) {
                await this.onSave({ $queue: this.queue });
            }
        }
        catch (e) {
            this.ngToast.warning(this.$translate.instant('modules.application.detail.attendance.queue-management.warning'));
        }
        finally {
            this.isLoading = false;
        }
    }
    returnQueue() {
        this.changeMode({ $queueName: this.queue.name, $queueId: this.queue.id });
    }
}
QueueItemController.$inject = ['SegmentService', '$translate', 'ngToast', '$state', 'QueuesService'];
